import React from "react";
import HomeComponent from "../components/HomeComponent";
import Layout from "../components/Layout";
const Home = () => {
  return (
    <>
      <Layout/>
      <div>
        <HomeComponent  />
      </div>
    </>
  );
};

export default Home;
